// extracted by mini-css-extract-plugin
export var caption = "Caption-module--caption--uvnhM";
export var captionResponsive = "Caption-module--caption-responsive--aCzeA";
export var cdsAssistiveText = "Caption-module--cds--assistive-text--SbY8J";
export var cdsVisuallyHidden = "Caption-module--cds--visually-hidden--aNVQL";
export var hideFeedback = "Caption-module--hide-feedback--R0SKN";
export var showFeedback = "Caption-module--show-feedback--Aujyg";
export var skeleton = "Caption-module--skeleton--lXRAw";